module.exports = __webpack_public_path__ + "img/compitacenter.5df9503a.svg";